import React from 'react'
import styled from 'styled-components'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import Avatar from 'components/complex/user/avatar'
import ModalStandardWrapper from 'components/modals/v2/modal_standard_wrapper'
import { colors } from 'helpers/colors'
import ReferralTimeline from './components/referral_timeline'
import { noSelect } from 'helpers/style'
import ModalCloseButtonV2 from '../modal_close_button_v2'
import SvgWarningSolid from 'components/reusable/svg/svg_warning_solid'

const ModalStyledWrapper = styled(ModalStandardWrapper)`
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`

const Header = styled(Flex)`
  width: 100%;
  margin-bottom: 24px;
`

const PendingCreditBadge = styled(Flex)`
  width: 100%;
  padding: 12px 8px;
  background: ${colors.gray[50]};
  border-radius: 8px;
  margin-bottom: 24px;
  ${noSelect}
`

function ReferralDetailsModal({ modalProps, onClose }) {
  const { referral } = modalProps || {}
  
  if (!referral) return null

  const { referree, reward, brief_ledger = [] } = referral
  const pendingCredit = Math.round(parseFloat(reward || 0))
  const isPayoutFailed = brief_ledger.some(item => item.new_status === 'payout_failed')
  const isPayoutPaid = brief_ledger.some(item => item.new_status === 'payout_paid')

  return (
    <ModalStyledWrapper ai="flex-start" jc="flex-start">
      <ModalCloseButtonV2 onClose={onClose} />

      <Header jc="flex-start" ai="center" gap={16}>
        <Avatar
          width={48}
          user={{
            first_name: referree?.first_name,
            last_name: referree?.last_name,
            profile_image: referree?.profile_image,
          }}
        />
        <Flex dir="column" ai="flex-start" gap={4}>
          <Text size={18} weight={500}>
            {referree?.first_name} {referree?.last_name}
          </Text>
          <Text color={colors.gray[400]}>
            {referree?.specific_type}
          </Text>
        </Flex>
      </Header>

      {pendingCredit > 0 && (
        <PendingCreditBadge jc="center" ai="center" gap={8}>
          {isPayoutFailed && <SvgWarningSolid size={23} color={colors.primary[500]} />}
          <Flex ai="center">
            <Text weight={500}>
              ${pendingCredit}
            </Text>
            &nbsp;
            <Text>
              {isPayoutFailed ? 'credit failed' : isPayoutPaid ? 'paid credit' : 'pending credit'}
            </Text>
          </Flex>
        </PendingCreditBadge>
      )}

      <ReferralTimeline ledger={brief_ledger} />
    </ModalStyledWrapper>
  )
}

export default ReferralDetailsModal
